// Utility for managing app_id in localStorage
// Now uses centralized project configuration

import { getProjectByAppId, getProjectByName, PROJECTS_CONFIG } from '../projectConfig/projects'

const APP_ID_STORAGE_KEY = 'app_id'

/**
 * Get app_id from localStorage
 * @returns {number} app_id (defaults to 1 if not set)
 */
export const getAppIdFromStorage = () => {
	const stored = localStorage.getItem(APP_ID_STORAGE_KEY)
	if (stored === null || stored === undefined) {
		// Default to 1 (LTax) if nothing is stored
		localStorage.setItem(APP_ID_STORAGE_KEY, '1')
		return 1
	}
	const appId = Number(stored)
	return isNaN(appId) ? 1 : appId
}

/**
 * Save app_id to localStorage
 * @param {number} appId - app_id value to save
 */
export const saveAppIdToStorage = (appId) => {
	if (appId !== null && appId !== undefined) {
		const appIdNum = Number(appId)
		if (!isNaN(appIdNum)) {
			localStorage.setItem(APP_ID_STORAGE_KEY, appIdNum.toString())
		}
	}
}

/**
 * Check if running on localhost
 * @returns {boolean}
 */
export const isLocalhost = () => {
	const host = window.location.hostname
	return host === 'localhost' ||
		host === '127.0.0.1' ||
		host === '[::1]' ||
		/\.local$/.test(host)
}

/**
 * Map app_id to project name
 * Uses centralized project configuration
 * @param {number} appId - app_id value
 * @returns {string|null} project name or null
 */
export const appIdToProjectName = (appId) => {
	const project = getProjectByAppId(appId)
	return project?.name || null
}

/**
 * Map project name to app_id
 * Uses centralized project configuration
 * @param {string} projectName - project name
 * @returns {number|null} app_id or null
 */
export const projectNameToAppId = (projectName) => {
	if (!projectName) return null
	const project = getProjectByName(projectName)
	return project?.appId || null
}

/**
 * Get initial project based on environment
 * For localhost: from app_id
 * For production: from selectedProject
 * @returns {string} project name (defaults to 'LTax')
 */
export const getInitialProject = () => {
	if (isLocalhost()) {
		// For localhost: get from app_id
		const appId = getAppIdFromStorage()
		return appIdToProjectName(appId) || 'LTax'
	} else {
		// For production: get from selectedProject (legacy support)
		return localStorage?.getItem('selectedProject') || 'LTax'
	}
}

